import { z } from "zod";
import { LookupListPage } from "@/pages/admin/lookups/LookupListPage";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

interface Row { decoMethodCode: string; decoMethodName: string; description: string | null; deleted: boolean; }
const schema = z.object({
  decoMethodCode: z.string().min(1).max(20),
  decoMethodName: z.string().min(1).max(100),
  description: z.string().max(500).nullable().optional(),
  deleted: z.boolean(),
});
type Form = z.infer<typeof schema>;

export function BomDecoMethodsPage() {
  return <LookupListPage<Row, Form>
    title="Deco methods"
    apiPath="/api/lookups/bom-deco-methods"
    schema={schema}
    rowKey={(r) => r.decoMethodCode}
    columns={[
      { id: "code", header: "Code", accessor: (r) => r.decoMethodCode },
      { id: "name", header: "Name", accessor: (r) => r.decoMethodName },
    ]}
    toFormValues={(r) => ({ decoMethodCode: r.decoMethodCode, decoMethodName: r.decoMethodName, description: r.description ?? "", deleted: r.deleted })}
    toApiBody={(f) => ({ ...f, description: f.description === "" ? null : f.description })}
    blankFormValues={{ decoMethodCode: "", decoMethodName: "", description: "", deleted: false }}
    fields={(f) => (
      <div className="space-y-3">
        <div><Label htmlFor="c">Code</Label><Input id="c" {...f.register("decoMethodCode")} /></div>
        <div><Label htmlFor="n">Name</Label><Input id="n" {...f.register("decoMethodName")} /></div>
        <div><Label htmlFor="d">Description</Label><Input id="d" {...f.register("description")} /></div>
        <Button type="submit">Save</Button>
      </div>
    )}
  />;
}
